export default __webpack_public_path__ + "static/media/vector2.15553ccb.svg";